import { Component, OnInit, Input } from '@angular/core';
import { Company, OverviewProvider } from '@lighty';
import { RedirectService } from '@services';

@Component({
    selector: 'msc-widget-next-event',
    templateUrl: './next-event.component.html'
})
export class WidgetNextEventComponent implements OnInit {
    @Input() company: Company;
    // Cuando el widget vive dentro de un modal que empieza oculto (visible solo por CSS, no por
    // *ngIf, así que este componente se monta siempre), autoLoad=false evita pedir los próximos
    // eventos hasta que alguien realmente abra el modal (ver overview.component.ts::openModal).
    @Input() autoLoad: boolean = true;
    public events: any[] = [];
    public loading: boolean = true;
    private loaded = false;

    constructor(private overviewProvider: OverviewProvider, private redirectService: RedirectService) {}

    ngOnInit(): void {
        if (this.autoLoad) {
            this.load();
        }
    }

    load(): void {
        if (this.loaded) {
            return;
        }
        this.loaded = true;
        this.loading = true;
        this.overviewProvider.getNextEvent(this.company.id).subscribe((data) => {
            this.events = data;
            this.loading = false;
        });
    }

    redirectPlayer(event: any): void {
        if (!event.isLocked) {
            this.redirectService.navigate('player', ['course', event.courseId, 'section', event.sectionId, 'event', event.eventId]);
        }
    }
}
